// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contact_wrapper__OGV6Z","container":"contact_container__fpMcs","text":"contact_text__8EWs_"};